import { Component, createRef } from 'react';
import { Translation } from 'react-i18next';

type Props = {
    iframeUrl: string,
}

class Invoices extends Component<Props> {
    private iframeRef = createRef<HTMLIFrameElement>();
    private initialScroll = { x: 0, y: 0 };

    componentDidMount() {
        this.initialScroll = { x: window.scrollX, y: window.scrollY };

        const preventScroll = (e: WheelEvent | TouchEvent) => e.preventDefault();
        window.addEventListener('wheel', preventScroll, { passive: false });
        window.addEventListener('touchmove', preventScroll, { passive: false });

        const resetInterval = setInterval(() => {
            window.scrollTo(this.initialScroll.x, this.initialScroll.y);
        }, 50);

        setTimeout(() => {
            window.removeEventListener('wheel', preventScroll);
            window.removeEventListener('touchmove', preventScroll);
            clearInterval(resetInterval);
        }, 2000);

        this.iframeRef.current?.addEventListener('load', this.handleIframeLoad);
    }

    componentWillUnmount() {
        this.iframeRef.current?.removeEventListener('load', this.handleIframeLoad);
    }

    private handleIframeLoad = () => {
        const doc = this.iframeRef.current?.contentDocument;
        doc?.querySelectorAll('[autofocus]').forEach(el => el.removeAttribute('autofocus'));
        if (doc?.activeElement && doc.activeElement !== doc.body) {
            (doc.activeElement as HTMLElement).blur();
        }
    }

    render() {
        return (
            <div className="dw-card grid">
                <div className="invoices-integration-container">
                    <h4><Translation>{t => t("Invoices/Credit Memo")}</Translation></h4>
                    <iframe
                        ref={this.iframeRef}
                        title="Invoices"
                        src={this.props.iframeUrl}
                        width="100%"
                        height="800px"
                        style={{ border: 'none', display: 'block' }}
                    />
                </div>
            </div>
        );
    }
}

export default Invoices;